import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPlay, FaTimes } from 'react-icons/fa';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import './VideoShowcase.css';

const VideoShowcase = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const videos = [
    {
      id: 1,
      title: 'Video Showcase 1',
      category: 'Videography',
      duration: '0:45',
      vimeoId: '1140691407',
      thumbnail: 'https://vumbnail.com/1140691407.jpg'
    },
    {
      id: 2,
      title: 'Video Showcase 2',
      category: 'Videography',
      duration: '1:20',
      vimeoId: '1140692589',
      thumbnail: 'https://vumbnail.com/1140692589.jpg'
    },
    {
      id: 3,
      title: 'Video Showcase 3',
      category: 'Videography',
      duration: '0:58',
      vimeoId: '1140716054',
      thumbnail: 'https://vumbnail.com/1140716054.jpg'
    }
  ];

  return (
    <section id="videos" className="video-showcase">
      <div className="video-container">
        <motion.div
          className="video-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Video Productions</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            Cinematic storytelling that brings your vision to life
          </p>
        </motion.div>

        <div className="video-grid">
          {videos.map((video, index) => (
            <motion.div
              key={video.id}
              className="video-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              onClick={() => setSelectedVideo(video)}
            >
              <div className="video-thumbnail">
                {video.vimeoId ? (
                  <img 
                    src={video.thumbnail} 
                    alt={video.title}
                    className="video-thumb-preview"
                  />
                ) : (
                  <video 
                    src={video.thumbnail} 
                    className="video-thumb-preview"
                    preload="metadata"
                    muted
                    playsInline
                  />
                )}
                <div className="play-button">
                  <FaPlay />
                </div>
                <div className="video-duration">{video.duration}</div>
              </div>
              <div className="video-info">
                <h3 className="video-title">{video.title}</h3>
                <p className="video-category">{video.category}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {selectedVideo && (
        <motion.div
          className="video-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setSelectedVideo(null)}
        >
          <button className="modal-close" onClick={() => setSelectedVideo(null)}>
            <FaTimes />
          </button>
          <motion.div
            className="modal-content"
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.8 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="video-player-wrapper">
              {selectedVideo.vimeoId ? (
                <iframe
                  src={`https://player.vimeo.com/video/${selectedVideo.vimeoId}?autoplay=1&title=0&byline=0&portrait=0`}
                  className="vimeo-player"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                  title={selectedVideo.title}
                />
              ) : (
                <VideoPlayer 
                  src={selectedVideo.src}
                  poster={selectedVideo.thumbnail}
                />
              )}
            </div>
            <div className="modal-info">
              <h3>{selectedVideo.title}</h3>
              <p>{selectedVideo.category} • {selectedVideo.duration}</p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </section>
  );
};

export default VideoShowcase;
